// @flow
import { getCreator, postCreator } from '../../../http';
import environment from '../../../environment';
import { throwError, of } from 'rxjs';

import type { Address, Country } from '../../../entities';

export type BillingAddressReq = {
  country: Country;
  admin1Id: number;
  admin2Id: number;
  admin3Id?: number;
  address1: string;
  address2?: string;
  firstName: string;
  lastName: string;
  phone: string;
  zipCode: string;
};

export type ItemsOrderItemReq = {
  id: string;
  name: string;
  url: string;
  detail?: string;
  imageId: string;
  itemCategoryId: number;
  amount: number;
  price: string;
  originalPackaging: boolean;
  weight?: string;
  volumeTier?: string;
  shipping?: string;
};

export type ItemsOrderAndTokenReq = {
  type: string;
  method: string;
  purchaseCountry: Country;
  deliveryCountry: Country;
  billingCountry: Country;
  serviceTier: string;
  shippingAddress: Address;
  couponCode?: string;
  items: ItemsOrderItemReq[];
};

export type CardOrderAndTokenReq = {
  type: string;
  method: string;
  purchaseCountry: Country;
  deliveryCountry: Country;
  billingCountry: Country;
  serviceTier: string;
  shippingAddress: Address;
  couponCode?: string;
};

export type UpdateOrderPaymentMethodReq = {
  type: string;
  method: string;
  billingCountry: Country;
};

export type PaymentExecuteReq = {
  type: string;
  method: string;
  paymentData?: {
    token: string;
    deviceId?: string;
    parameters3DS?: {[key: string]: any};
  };
};

export const endpoints = Object.freeze({
  FETCH_ORDER: `${environment.apiUrl}/purchase/:orderId`,
  FETCH_PAYMENT_METHODS: `${environment.apiUrl}/meta/payment-methods/:country`,
  FETCH_BAG: `${environment.apiUrl}/bag/:bagId`,
  // Create token
  CREATE_CART_ORDER_AND_TOKEN: `${environment.apiUrl}/checkout/cart`,
  CREATE_ITEMS_ORDER_AND_TOKEN: `${environment.apiUrl}/checkout/items`,
  CREATE_BAG_ORDER_AND_TOKEN: `${environment.apiUrl}/checkout/bag/:bagId`,
  UPDATE_ORDER_PAYMENT_METHOD: `${environment.apiUrl}/checkout/order/:orderId`,
  // Checkout
  POST_PAYMENT_EXECUTE: `${environment.apiUrl}/checkout/payment/:paymentId`,
  // Apply coupon
  APPLY_COUPON: `${environment.apiUrl}/purchase/:orderId/coupon/add`,
  REMOVE_COUPON: `${environment.apiUrl}/purchase/:orderId/coupon/remove`,
});

export const fetchOrderApi = getCreator(fetch, endpoints.FETCH_ORDER);
export const fetchPaymentMethodsApi = getCreator(fetch, endpoints.FETCH_PAYMENT_METHODS);
// export const fetchPaymentMethodsApi = () => throwError({ code: 500, name: 'INTERNAL_SERVER_ERROR'});
// export const fetchBagApi = getCreator(fetch, endpoints.FETCH_BAG);
export const postCreateItemsOrderAndTokenApi = postCreator(fetch, endpoints.CREATE_ITEMS_ORDER_AND_TOKEN);
export const postCreateCartOrderAndTokenApi = postCreator(fetch, endpoints.CREATE_CART_ORDER_AND_TOKEN);
export const postCreateBagOrderAndTokenApi = postCreator(fetch, endpoints.CREATE_BAG_ORDER_AND_TOKEN);
export const putOrderPaymentMethodApi = postCreator(fetch, endpoints.UPDATE_ORDER_PAYMENT_METHOD);
export const postPaymentExecuteApi = postCreator(fetch, endpoints.POST_PAYMENT_EXECUTE);
export const applyCouponApi = postCreator(fetch, endpoints.APPLY_COUPON);
export const removeCouponApi = postCreator(fetch, endpoints.REMOVE_COUPON);
/*export const postPaymentExecuteApi = () => {
  console.log('postPaymentExecuteApi');
  return of({});
};*/
/*export const postPaymentExecuteApi = () => throwError({
  code: 400,
  name: 'BAD_REQUEST',
  data: { name: 'PaymentCaptureFailed' }
});*/




// WEBPACK FOOTER //
// ./src/modules/new-order/CheckoutStep/api.js